import { getEnvVar } from 'shared/config/lib/getEnvVar'
import { get_url_api } from 'shared/config/lib/getConfigUrls'

export type IAppType = 'react' | 'vue' | 'light' | 'calling-light'
export const APP_TYPE: IAppType = getEnvVar('APP_TYPE') as IAppType

/** Google Recaptcha **/
export const GOOGLE_RECAPTCHA_SITE_KEY_V2 = getEnvVar('GOOGLE_RECAPTCHA_SITE_KEY_V2')
export const GOOGLE_RECAPTCHA_SITE_KEY_V3 = getEnvVar('GOOGLE_RECAPTCHA_SITE_KEY_V3')

export const GOOGLE_RECAPTCHA_ENABLE = Boolean(
  GOOGLE_RECAPTCHA_SITE_KEY_V2 && GOOGLE_RECAPTCHA_SITE_KEY_V3
)

/** SENTRY */
export const SENTRY_DOMAIN = getEnvVar('SENTRY_DOMAIN')
export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE = getEnvVar('SENTRY_REPLAYS_SESSION_SAMPLE_RATE')
export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE = getEnvVar('SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE')
export const SENTRY_TRACES_SAMPLE_RATE = getEnvVar('SENTRY_TRACES_SAMPLE_RATE')
export const SENTRY_PROFILES_SAMPLE_RATE = getEnvVar('SENTRY_PROFILES_SAMPLE_RATE')
export const SENTRY_RELEASE = getEnvVar('SENTRY_RELEASE')

/** API entrypoint */
export const API_URL = getEnvVar('REACT_APP_API_URL')
export const API_VERSION_V5 = getEnvVar('REACT_APP_API_VERSION')
export const API_VERSION_V6 = 'v6'
export const API_PREFIX = getEnvVar('REACT_APP_API_PREFIX')
export const APP_ENV = getEnvVar('REACT_APP_ENV')

export const APP_LOCALHOST = window.location.host.includes('localhost')

export const NODE_ENV = getEnvVar('NODE_ENV')

export const isLocalEnv = APP_ENV === 'local'
export const isProdEnv = APP_ENV === 'production'

export const PUSHER_DRIVER = getEnvVar('REACT_APP_PUSHER_DRIVER')
export const SOKETI_KEY = getEnvVar('REACT_APP_SOKETI_KEY')
export const SOKETI_HOST = getEnvVar('REACT_APP_SOKETI_HOST')
export const LOGGER_BASE_URL = getEnvVar('REACT_APP_LOGGER_BASE_URL')
export const SOKETI_CLUSTER = getEnvVar('REACT_APP_PUSHER_CLUSTER')

export const STRIPE_KEY = getEnvVar('STRIPE_KEY')

export const RETENTLY_TRACKING_ID = getEnvVar('RETENTLY_TRACKING_ID')

export const CDN_FRONT = getEnvVar('REACT_APP_CDN_FRONT')

export const CDN_URL = getEnvVar('REACT_APP_CDN_URL')

export const WIDGET_LIGHT_PUBLIC_PATH = getEnvVar('WIDGET_LIGHT_PUBLIC_PATH')
export const CALLING_LIGHT_PUBLIC_PATH = getEnvVar('CALLING_LIGHT_PUBLIC_PATH')
export const IS_APP_LIGHT = APP_TYPE === 'light'
export const IS_CALLING_APP_LIGHT = APP_TYPE === 'calling-light'

export const PUBLIC_PATH = (() => {
  if (IS_APP_LIGHT) {
    return WIDGET_LIGHT_PUBLIC_PATH
  }
  if (IS_CALLING_APP_LIGHT) {
    return CALLING_LIGHT_PUBLIC_PATH
  }
})()

export const TCR_DOMAIN = getEnvVar('TCR_DOMAIN')

export const LIST_MICROSERVICES = [
  'segment',
  'ai',
  'admin',
  'billing',
  'workflows',
  'chatbot',
  'logger',
  'smart-tts',
  'compliance',
  'integration',
  'campaign',
  'calendar',
  'compliance-ai',
  'analytics',
  'installations',
  'external-webhooks',
  'agents',
  'activity-logs',
  'calling-agent',
  'auth/api/v2',
]

export const GET_API_MICROSERVICE = () => {
  return `${get_url_api(API_URL)}/${API_VERSION_V5}/`
}

export const GET_API_V5 = () => {
  return `${get_url_api(API_URL)}/${API_VERSION_V5}/${API_PREFIX}/`
}

export const GET_API_V6 = () => {
  return `${get_url_api(API_URL)}/${API_VERSION_V6}/${API_PREFIX}/`
}

export const GET_API_URL = () => {
  if (API_PREFIX) {
    return GET_API_V5()
  }

  return GET_API_MICROSERVICE()
}

export const API_URL_MICROSERVICE = GET_API_MICROSERVICE()

localStorage.setItem('API_URL_CORE', GET_API_URL())

export const LIST_CDN = [
  'salesmessage-dev.s3.us-west-2.amazonaws.com',
  'salesmessage-develop.s3.us-west-2.amazonaws.com',
  'salesmessage-release.s3.us-west-2.amazonaws.com',
  'salesmessage-stage.s3.us-west-2.amazonaws.com',
  'salesmessage-qa.s3.us-west-2.amazonaws.com',
  'salesmessage-prod.s3.us-west-2.amazonaws.com',

  'dev-media.salesmessage.com',
  'develop-media.salesmessage.com',
  'release-media.salesmessage.com',
  'stage-media.salesmessage.com',
  'qa-media.salesmessage.com',
  'media.salesmessage.com',
]
